import React, { useEffect, useRef, useState } from 'react';
import { useCamera } from '../../common/hooks';

const CameraPreview = () => {
    const videoRef = useRef(null);
    const localStream = useCamera();
    const audioContext = useRef(null);
    const analyser = useRef(null);
    const [volume, setVolume] = useState(0);

    useEffect(() => {
        if (localStream && videoRef.current) {
            videoRef.current.srcObject = localStream;

            // Setup Web Audio API
            audioContext.current = new (window.AudioContext || window.webkitAudioContext)();
            analyser.current = audioContext.current.createAnalyser();
            const source = audioContext.current.createMediaStreamSource(localStream);
            source.connect(analyser.current);
            analyser.current.fftSize = 256;
        }

        return () => {
            if (audioContext.current) {
                audioContext.current.close();
            }
        };
    }, [localStream]);

    useEffect(() => {
        let animationFrameId;

        const updateVolume = () => {
            if (analyser.current) {
                const dataArray = new Uint8Array(analyser.current.frequencyBinCount);
                analyser.current.getByteFrequencyData(dataArray);
                let sum = 0;
                for (let i = 0; i < dataArray.length; i++) {
                    sum += dataArray[i];
                }
                const average = sum / dataArray.length;
                setVolume(average);
                animationFrameId = requestAnimationFrame(updateVolume);
            }
        };

        // Start the initial volume update
        updateVolume();

        // Cleanup function to cancel animation frame
        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    // Interval to update volume every 3 seconds
    useEffect(() => {
        const intervalId = setInterval(() => {
            // Trigger updateVolume() to get the latest volume level
            if (analyser.current) {
                const dataArray = new Uint8Array(analyser.current.frequencyBinCount);
                analyser.current.getByteFrequencyData(dataArray);
                let sum = 0;
                for (let i = 0; i < dataArray.length; i++) {
                    sum += dataArray[i];
                }
                const average = sum / dataArray.length;
                setVolume(average);
            }
        }, 500);

        // Cleanup function to clear the interval
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    return (
        <div>
            <video width="100" height="100" ref={videoRef} autoPlay playsInline />
            <div>Volume Level: {volume}</div>
        </div>
    );
};

export default CameraPreview;
